"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Secp256k1InitialState = exports.TransferableOp = void 0;
const utils_1 = require("../../utils");
const constants_1 = require("../constants");
class TransferableOp {
    assetId;
    utxoIds;
    op;
    constructor(assetId, utxoIds, op) {
        this.assetId = assetId;
        this.utxoIds = utxoIds;
        this.op = op;
    }
    serialize() {
        throw new Error('not implemented');
    }
    static comparator = (a, b) => {
        return utils_1.JuneoBuffer.comparator(a.serialize(), b.serialize());
    };
}
exports.TransferableOp = TransferableOp;
class Secp256k1InitialState {
    fxId = constants_1.Secp256k1InitialStateFxId;
    outputs;
    constructor(outputs) {
        this.outputs = outputs;
    }
    serialize() {
        const outputsBytes = [];
        let outputsSize = 0;
        for (const output of this.outputs) {
            const bytes = output.serialize();
            outputsSize += bytes.length;
            outputsBytes.push(bytes);
        }
        const buffer = utils_1.JuneoBuffer.alloc(4 + 4 + outputsSize);
        buffer.writeUInt32(this.fxId);
        buffer.writeUInt32(this.outputs.length);
        for (const bytes of outputsBytes) {
            buffer.write(bytes);
        }
        return buffer;
    }
}
exports.Secp256k1InitialState = Secp256k1InitialState;
